import { composeClassNames, getImageUrl } from "@faedev/editor-utils";
import Link from "next/link";
import { CSSProperties } from "react";
import { Col, Image, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import constants from "src/constants";
import LogoBenefitPlus from "src/icons/Logo-benefit-plus";
import LogoBenefity from "src/icons/Logo-benefity";
import LogoSodexo from "src/icons/Logo-sodexo";
import { sCafeterias } from "src/styles/sCafeterias.module.scss";
import { CSSTextAlign } from "src/types/CSSTextAlign";

type Props = {
  align?: CSSTextAlign | null | undefined;
  color?: ("light" | "grey" | "dark" | "original") | null | undefined;
  className?: (string | string) | null | undefined;
  size?: ("sm" | "lg") | null | undefined;
  style?: CSSProperties | null | undefined;
};

function Cafeterias({
  align,
  color = "original",
  className,
  size = "sm",
  style,
}: Props) {
  return (
    <div
      className={composeClassNames([
        sCafeterias,
        align,
        color,
        size,
        className,
      ])}
      style={style}
      id="cafeterias"
    >
      {size === "sm" ? (
        <>
          <div
            className="cafeteria-logotype"
            style={{ bottom: constants.Size.sm }}
          >
            <Link href={constants.Paths.cafeteriasSodexo} passHref>
              <a target="_blank">
                <LogoSodexo className="cafeteria-logotype-image" />
              </a>
            </Link>
          </div>

          <div className="cafeteria-logotype">
            <Link href={constants.Paths.cafeteriasBenefity} passHref>
              <a target="_blank">
                <LogoBenefity className="cafeteria-logotype-image" />
              </a>
            </Link>
          </div>

          <div className="cafeteria-logotype">
            <Link href={constants.Paths.cafeteriasBenefitPlus} passHref>
              <a target="_blank">
                <LogoBenefitPlus className="cafeteria-logotype-image" />
              </a>
            </Link>
          </div>
        </>
      ) : (
        <Row>
          <Col xs={12} sm={5} lg={6} className="cafeterias-label">
            <Heading
              type="h3"
              className="cafeterias-heading"
              title={<Translate tKey="You can find us in these cafeterias" />}
            />
            <Paragraph size="xn" className="cafeterias-description">
              <Translate tKey="Get contentment and health through your employee benefits, vouchers or electronic cards." />
            </Paragraph>
          </Col>
          <Col xs={12} sm={7} lg={6} className="cafeterias-list">
            <div
              className="cafeteria-logotype"
              style={{ bottom: constants.Size.sm }}
            >
              <Link href={constants.Paths.cafeteriasSodexo} passHref>
                <a target="_blank">
                  <Image
                    alt="Sodexo"
                    className="cafeteria-logotype-image"
                    src={getImageUrl("/images/logotypes/logo_sodexo.svg")}
                  />
                </a>
              </Link>
            </div>

            <div className="cafeteria-logotype">
              <Link href={constants.Paths.cafeteriasBenefity} passHref>
                <a target="_blank">
                  <Image
                    alt="Benefity"
                    className="cafeteria-logotype-image"
                    src={getImageUrl("/images/logotypes/logo_benefity.svg")}
                  />
                </a>
              </Link>
            </div>

            <div className="cafeteria-logotype">
              <Link href={constants.Paths.cafeteriasBenefitPlus} passHref>
                <a target="_blank">
                  <Image
                    alt="Benefity"
                    className="cafeteria-logotype-image"
                    src={getImageUrl("/images/logotypes/logo_benefit_plus.svg")}
                  />
                </a>
              </Link>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default Cafeterias;
